import { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';
import { Icon, icons } from '@/components/common/Icon';
import Image from '@/components/common/Image';

interface LeadershipMember {
  name: string;
  title: string;
  image: string;
  linkedIn?: string;
}

interface LeadershipProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  members: LeadershipMember[];
}

export const Leadership = ({
  title,
  description,
  members,
  className,
  ...props
}: LeadershipProps) => {
  return (
    <section className={cn('py-20 bg-black text-white', className)} {...props}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="max-w-xl">
            <h2 className="text-4xl font-bold  mb-6">{title}</h2>
            <p className="text-xl text-gray-600">{description}</p>
          </div>

          <div className="grid grid-cols-2 gap-8">
            {members.map((member, index) => (
              <div key={index} className="flex flex-col">
                <div className="relative mb-4">
                  <Image
                    src={member.image}
                    alt={member.name}
                    className="w-full aspect-square object-cover rounded-lg"
                  />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="text-xl font-semibold ">
                      {member.name}
                    </h3>
                    {member.linkedIn && (
                      <a
                        href={member.linkedIn}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-600 hover:text-primary-600"
                      >
                        <Icon icon={icons.linkedin} className="w-5 h-5" />
                      </a>
                    )}
                  </div>
                  <p className="text-gray-600">{member.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};